import type RootStore from "stores/RootStore";
import type ServiceStore from "stores/ServiceStore";
import { RouteType } from "types/RouteType";

/**
 * Install Drawings Upload Route — P0 from the 2026-06-08 client meeting.
 *
 * Renders a per-project accordion at /app/install with three sub-sections each
 * (shop drawings, erection drawings, photos). Stamping/markup is deferred.
 *
 * Two stores are warmed on entry: `projectsStore` (so the accordion list is
 * instant) and `installDocumentsStore` (so existing uploads show without an
 * empty-flash). Both are wide finds — install_documents is small (one row per
 * uploaded file) and projects is already cached site-wide.
 */
const InstallRoute: RouteType = {
  name: "Install",
  path: "/install",
  title: "Install Drawings",
  layout: "/app",
  group: "Install",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  viewportCard: {
    header: {
      component: () => import("./Install.Page"),
      title: "Install Drawings",
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./Install.Body"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    try {
      const projectsStore = (
        rootStore as unknown as Record<string, ServiceStore | undefined>
      ).projectsStore;
      const installDocumentsStore = (
        rootStore as unknown as Record<string, ServiceStore | undefined>
      ).installDocumentsStore;

      await Promise.allSettled([
        projectsStore?.find?.({ query: { $limit: 1000 } }),
        installDocumentsStore?.find?.({
          query: { $limit: 5000, $sort: { createdAt: -1 } },
        }),
      ]);
    } catch (error) {
      console.warn("[InstallRoute] warm-load failed:", error);
    }
    return true;
  },
};

export default InstallRoute;
